import { INK, PALETTE, TYPE } from "@gaoya/shared";
import type { Rect } from "@gaoya/shared";
import type { UiButton } from "../../ui/hall.js";
import { ENAMEL, enamelLabel, fillEnamel } from "../theme.js";

function cup(ctx: CanvasRenderingContext2D, cx: number, cy: number, scale: number, full: boolean, now: number): void {
  ctx.save();
  ctx.translate(cx, cy);
  ctx.scale(scale, scale);
  if (!full) {
    ctx.rotate(0.85);
    ctx.translate(4, 10);
  }

  ctx.fillStyle = "#C9B89A";
  ctx.beginPath();
  ctx.ellipse(0, 16, 16, 4, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = PALETTE.ink;
  ctx.lineWidth = 1.1;
  ctx.stroke();

  const body = ctx.createLinearGradient(-14, -8, 14, 14);
  body.addColorStop(0, "#F4EFE3");
  body.addColorStop(0.5, "#E4D7C0");
  body.addColorStop(1, "#CDB892");
  ctx.fillStyle = body;
  ctx.beginPath();
  ctx.moveTo(-13, -2);
  ctx.quadraticCurveTo(-16, 10, -8, 14);
  ctx.lineTo(8, 14);
  ctx.quadraticCurveTo(16, 10, 13, -2);
  ctx.closePath();
  ctx.fill();
  ctx.stroke();

  if (full) {
    ctx.fillStyle = INK.tea;
    ctx.beginPath();
    ctx.ellipse(0, 0, 9, 3.2, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = "rgba(242,239,230,0.35)";
    ctx.beginPath();
    ctx.ellipse(-3, -0.6, 3, 1.2, -0.4, 0, Math.PI * 2);
    ctx.fill();
  }

  ctx.fillStyle = "#EFE6D4";
  ctx.beginPath();
  ctx.ellipse(0, -8, 11, 3.4, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(0, -12, 3, 0, Math.PI * 2);
  ctx.fill();
  ctx.stroke();
  ctx.restore();

  if (!full) {
    ctx.fillStyle = INK.teaWash;
    ctx.beginPath();
    ctx.ellipse(cx + 10 * scale, cy + 16 * scale, 12 * scale, 4 * scale, 0.2, 0, Math.PI * 2);
    ctx.fill();
  }
  void now;
}

/** 满杯数 = hp。从右往左倾覆。 */
export function drawCupRow(
  ctx: CanvasRenderingContext2D,
  area: Rect,
  hp: number,
  now: number,
  scale = 1,
): void {
  const n = 3;
  const filled = Math.max(0, Math.min(n, Math.floor(hp)));
  const gap = Math.min(28, Math.max(22, area.w / 4.2));
  const total = gap * (n - 1);
  const x0 = area.x + area.w / 2 - total / 2;
  const cy = area.y + area.h * 0.55;
  const fitted = (area.h * 0.8) / 32;
  const s = scale * Math.min(1.05, Math.max(0.55, fitted));
  for (let i = 0; i < n; i++) {
    const full = i < filled;
    cup(ctx, x0 + i * gap, cy, s, full, now);
  }
}

const ITEM_BTN_W = 72;
const ITEM_BTN_H = 32;
const ITEM_BTN_GAP = 4;

export function itemColumnRects(self: Rect): { scramble: Rect; hint: Rect } {
  const total = ITEM_BTN_H * 2 + ITEM_BTN_GAP;
  const x = self.x + self.w - 12 - ITEM_BTN_W;
  const y = self.y + Math.max(2, (self.h - total) / 2);
  return {
    scramble: { x, y, w: ITEM_BTN_W, h: ITEM_BTN_H },
    hint: { x, y: y + ITEM_BTN_H + ITEM_BTN_GAP, w: ITEM_BTN_W, h: ITEM_BTN_H },
  };
}

export function hintButtonRect(self: Rect): Rect {
  return itemColumnRects(self).hint;
}

export function hintPouchRect(self: Rect, _index = 0): Rect {
  return hintButtonRect(self);
}

export function layoutHintPouches(self: Rect): UiButton[] {
  const col = itemColumnRects(self);
  return [
    {
      id: "scramble-0",
      label: "",
      x: col.scramble.x,
      y: col.scramble.y,
      w: col.scramble.w,
      h: col.scramble.h,
      kind: "silent",
    },
    {
      id: "hint-0",
      label: "",
      x: col.hint.x,
      y: col.hint.y,
      w: col.hint.w,
      h: col.hint.h,
      kind: "silent",
    },
  ];
}

function drawItemChip(ctx: CanvasRenderingContext2D, r: Rect, label: string, on: boolean): void {
  const tone = on ? ENAMEL.gamboge : ENAMEL.porcelain;
  const face = fillEnamel(ctx, r.x, r.y, r.w, r.h, 10, tone);
  ctx.font = `700 13px ${TYPE.sans}`;
  enamelLabel(ctx, on ? label : "已用完", face.x + face.w / 2, face.y + face.h / 2, on ? tone.ink : "#9E8D7E");
}

export function drawHintPouches(
  ctx: CanvasRenderingContext2D,
  self: Rect,
  hintsLeft: number,
  scrambleItemsLeft = 0,
): void {
  const col = itemColumnRects(self);
  drawItemChip(ctx, col.scramble, `打乱 ×${scrambleItemsLeft}`, scrambleItemsLeft > 0);
  drawItemChip(ctx, col.hint, `提示 ×${hintsLeft}`, hintsLeft > 0);
}
